import { render, staticRenderFns } from "./AutoRefresh.vue?vue&type=template&id=12ece5b1"
import script from "./AutoRefresh.vue?vue&type=script&lang=ts"
export * from "./AutoRefresh.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports